// src/utils/fixEncoding.js

/**
 * Corregge i problemi di codifica UTF-8
 * Converte caratteri mal interpretati in caratteri corretti
 */
export const fixEncoding = (text) => {
    if (!text) return text;
    if (typeof text !== 'string') return text;
    
    return text
        // Simboli di grado e temperatura
        .replace(/┬║/g, '°')
        .replace(/┬░/g, '°')
        .replace(/ΓÇö/g, '—')
        .replace(/ΓÇ£/g, '"')
        .replace(/ΓÇ¥/g, '"')
        .replace(/ΓÇÿ/g, "'")
        .replace(/ΓÇÖ/g, "'")
        .replace(/Γé¼/g, '€')
        .replace(/Γäó/g, '™')
        .replace(/Γ┼í/g, 'š')
        .replace(/Γì│/g, 'è')
        .replace(/Γ¿│/g, 'é')
        .replace(/Γ¿á/g, 'à')
        // Accenti comuni
        .replace(/├í/g, 'á')
        .replace(/├®/g, 'é')
        .replace(/├¡/g, 'í')
        .replace(/├│/g, 'ó')
        .replace(/├║/g, 'ú')
        .replace(/├▒/g, 'ñ')
        .replace(/├º/g, 'ç')
        .replace(/├╝/g, 'ü')
        .replace(/├¿/g, 'è')
        .replace(/├¼/g, 'ì')
        .replace(/├▓/g, 'ò')
        .replace(/├╣/g, 'ù');
};

/**
 * Corregge ricorsivamente la codifica di un oggetto o array
 */
export const fixDataEncoding = (data) => {
    if (!data) return data;
    if (typeof data === 'string') return fixEncoding(data);
    if (Array.isArray(data)) return data.map(item => fixDataEncoding(item));
    if (typeof data === 'object') {
        const result = {};
        for (const key in data) {
            result[key] = fixDataEncoding(data[key]);
        }
        return result;
    }
    return data;
};